import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AuditStamp, auditActorLabel } from './audit.models';

@Component({
  selector: 'app-audit-directory-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="audit-line"><span>Created</span><strong>{{ label(stamp?.createdByActor, stamp?.createdBy, stamp?.createdAuditSource) }}</strong><small>{{ stamp?.createdAt ? (stamp?.createdAt | date:'short') : 'Not recorded' }}</small></div>
    <div class="audit-line"><span>Updated</span><strong>{{ label(stamp?.updatedByActor, stamp?.updatedBy, stamp?.updatedAuditSource) }}</strong><small>{{ stamp?.updatedAt ? (stamp?.updatedAt | date:'short') : 'Not recorded' }}</small></div>
    <div class="audit-line"><span>Deleted</span><strong>{{ stamp?.deletedAt ? label(stamp?.deletedByActor, stamp?.deletedBy) : 'Not deleted' }}</strong><small *ngIf="stamp?.deletedAt">{{ stamp?.deletedAt | date:'short' }}</small></div>
  `,
  styles: [`
    .audit-line { display: flex; flex-wrap: wrap; gap: .25rem .5rem; font-size: .75rem; line-height: 1.3; }
    .audit-line + .audit-line { margin-top: .3rem; }
    .audit-line span { color: #64748b; min-width: 3.5rem; }
    .audit-line strong { color: #1e293b; font-weight: 600; }
    .audit-line small { color: #64748b; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDirectoryCellComponent {
  @Input() stamp?: AuditStamp | null;
  readonly label = auditActorLabel;
}
